import { FC, Suspense } from 'react';

import { FullPageLoading } from './components/loading/FullPageLoading';
import { GeneratedRoutes } from './lib/routes/generator';
import { routes } from './routes';

export const AppRouter: FC = () => {
  return (
    <Suspense fallback={<FullPageLoading />}>
      <GeneratedRoutes routes={routes} />
    </Suspense>
  );
};
